import { render, staticRenderFns } from "./OfferForm.vue?vue&type=template&id=b8664be2&scoped=true"
import script from "./OfferForm.vue?vue&type=script&lang=js"
export * from "./OfferForm.vue?vue&type=script&lang=js"
import style0 from "./OfferForm.vue?vue&type=style&index=0&id=b8664be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8664be2",
  null
  
)

export default component.exports